import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import { prototypeNavigate } from '../utils/prototypeNav';
import { ContentNote } from './ContentNote';
interface FinalCtaProps {
  title: string;
  citySlug: string;
  sportSlug?: string;
  browseLabel: string;
  onBrowse: () => void;
  showNote?: boolean;
}
export function FinalCta({
  title,
  citySlug,
  sportSlug,
  browseLabel,
  onBrowse,
  showNote = true
}: FinalCtaProps) {
  const [zip, setZip] = useState('');
  const [error, setError] = useState('');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\d{5}$/.test(zip)) {
      setError('Enter a 5-digit ZIP code.');
      return;
    }
    setError('');
    const sportParam = sportSlug ? `sport=${sportSlug}&` : '';
    prototypeNavigate(`Searching programs near ${zip}`, `/find-a-program?${sportParam}zip=${zip}&metro=${citySlug}`);
  };
  return <section aria-labelledby="final-cta" className="relative grid bg-brand-navy md:grid-cols-[1fr_1.15fr]" data-id="element-34" data-mp="1x51q7j9fhvw1">
      <div className="flex items-center justify-center bg-brand-red px-6 py-8 md:justify-end md:py-10 md:pr-16 md:[clip-path:polygon(0_0,100%_0,calc(100%-48px)_100%,0_100%)]" data-id="element-35" data-mp="n6e3tikdybus">
        <h2 id="final-cta" className="text-center font-display text-[30px] font-bold uppercase leading-tight text-white md:text-right md:text-[36px]" data-id="element-36" data-mp="x41yk8hzrjcy">
          {title}
        </h2>
      </div>
      <div className="flex flex-col justify-center bg-brand-navy px-6 py-8 md:px-10" data-id="element-37" data-mp="164gl1b6oz4i1">
        <form onSubmit={submit} noValidate className="flex w-full max-w-md" data-id="element-38" data-mp="162m9gnhb8oqm">
          <label htmlFor="final-zip" className="sr-only" data-id="element-39" data-mp="1b1qkzkrpiyk4">ZIP code</label>
          <input id="final-zip" inputMode="numeric" maxLength={5} value={zip} onChange={e => {
          setZip(e.target.value.replace(/\D/g, ''));
          setError('');
        }} placeholder="Enter your ZIP code" aria-invalid={Boolean(error)} aria-describedby={error ? 'final-zip-error' : undefined} className="h-11 min-w-0 flex-1 rounded-l-sm border-0 px-3 text-sm text-brand-ink placeholder:text-brand-muted focus:outline-none focus:ring-2 focus:ring-brand-sky" data-id="element-40" data-mp="1fvbbkrqz0q9a" />
          <button type="submit" className="flex h-11 items-center gap-1.5 whitespace-nowrap rounded-r-sm bg-brand-red px-5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand-redDark" data-id="element-41" data-mp="3hcspfjxj91f">
            <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="df9c0un0taam" /> Search
          </button>
        </form>
        {error && <p id="final-zip-error" role="alert" className="mt-2 text-sm text-red-200" data-id="element-43" data-mp="8fmo9r9kgbnk">{error}</p>}
        <button type="button" onClick={onBrowse} className="mt-3 self-start text-sm text-white/85 underline-offset-2 hover:text-white hover:underline" data-id="element-44" data-mp="mgqrqbwin9ys">
          {browseLabel}
        </button>
      </div>
      {showNote && <ContentNote kind="hybrid" detail="Fixed template. ZIP opens Find a Program pre-filtered to sport." data-id="element-45" data-mp="2o8lolle459wy" />}
    </section>;
}